var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .85c.143 0 .28.05.387.14l.075.073 4.84 5.537a.4.4 0 0 1-.544.582l-.06-.056-.727-.832v3.78a.912.912 0 0 1-.73.952l-.116.015L6.4 11.04v1.549H11a.4.4 0 0 1 .08.792l-.08.008H1a.4.4 0 0 1-.08-.792L1 12.59h4.6V11.04H2.849c-.45-.03-.788-.405-.82-.838l-.001-3.908-.727.832a.4.4 0 0 1-.498.085l-.066-.047a.4.4 0 0 1-.085-.498L.699 6.6l4.837-5.535A.612.612 0 0 1 6 .85zm0 .899-3.172 3.63v4.733c-.003.057.02.1.036.119l.011.01 1.653-.001V7.901c0-.602.428-1.11.992-1.176l.123-.007h.714c.583 0 1.048.468 1.108 1.056l.006.127v2.34h1.627c.028-.001.06-.035.07-.097l.003-.051V5.378L6 1.749zm.357 5.77h-.714c-.145 0-.277.125-.308.303l-.006.08-.001 2.338h1.343V7.901a.39.39 0 0 0-.195-.354l-.058-.021-.06-.008z",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e3d3610a.svg";
export { ForwardRef as ReactComponent };